module.exports = __webpack_public_path__ + "img/temperature-grey.e76dffe8.svg";